import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import { createMarkup } from '../Helpers/FormHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export function HMA({ data, selectedItemData, onSelect }) {

  return (
    <div className="col-lg-4 col-md-6 col-sm-12">
      <div className="card">
        <img className="card-img" src={`${data?.filePathThumb}`} alt={`${data?.altText}`} />
        <div className={`card-img-overlay ${data.overlayText ? "" : "hide"}`} >
          <div className="card-text" dangerouslySetInnerHTML={createMarkup(data.overlayText)}></div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col-sm-8">
              <p className="card-title"><strong>{data?.title}</strong></p>
              <p dangerouslySetInnerHTML={createMarkup(data.descriptionHTML)}></p>
            </div>
            <div className="col-sm-4">
              <Link to="/" type="button" data-aria-selectedname={data?.title} id={data.id}
                className={`btn blm-btn-primary btn-block right ${selectedItemData.some(x => x.id === data.id) ? "active" : ""}`}
                onClick={(event) => { onSelect(event) }}>{selectedItemData.some(x => x.id === data.id) ? `Selected!` : `Select`}</Link>
            </div>
          </div>
          <NavButtons prevUrl="/" nextUrl="/Donate" show={selectedItemData.some(x => x.id === data.id)} enableNext={true} />
        </div>
      </div>
    </div>
  );

  function NavButtons({ prevUrl, nextUrl, show, enableNext }) {
    if (show) {
      return (
        <div className="row">
          <div className="col-sm-6 text-start">
            <Link className="btn btn-link" to={{ pathname: prevUrl }} >
              <FontAwesomeIcon icon={["fa", "angle-double-left"]} /> Previous
            </Link>
          </div>
          <div className="col-sm-6 text-end">
            <Link className={`btn btn-link ${enableNext ? "" : "disabled"}`} to={{
              pathname: nextUrl,
              state: { selectedItemData: selectedItemData }
            }} >
              Next <FontAwesomeIcon icon={["fa", "angle-double-right"]} />
            </Link>
          </div>
        </div>
      )
    } else {
      return (null)
    }
  }
}

HMA.propTypes = {
  data: PropTypes.object.isRequired,
  selectedItemData: PropTypes.array,
  onSelect: PropTypes.func.isRequired
};

